module.exports = __webpack_public_path__ + "static/media/course1.f84d1aeb.png";